import { useContext } from 'react';

import EnvCropsOrdersContext from './EnvCropsOrdersContext';

const useEnvCropsOrders = () => useContext(EnvCropsOrdersContext);

export default useEnvCropsOrders;
